import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export async function initPushNotifications(apiBase, token) {
  try {
    if (!('Notification' in window)) return;
    if (!('serviceWorker' in navigator)) return;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const fcmToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    if (!fcmToken) return;
    await fetch(apiBase + '/notifications/register-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
      body: JSON.stringify({ token: fcmToken }),
    });
    console.log('[FCM] token registered');

    onMessage(messaging, (payload) => {
      const matchId    = payload.data?.matchId    || '';
      const theirAlias = payload.data?.theirAlias || '';
      if (matchId) {
        // App is open — show overlay, skip OS notification
        window.dispatchEvent(new CustomEvent('binko:match', {
          detail: { matchId, theirAlias },
        }));
        return;
      }
      // Non-match foreground push
      const { title, body } = payload.notification || {};
      if (title && Notification.permission === 'granted') {
        new Notification(title, { body, icon: '/logo.png' });
      }
    });
  } catch (err) {
    console.warn('[FCM] init failed:', err.message);
  }
}
